import script from "./image-magnifier.vue?vue&type=script&setup=true&lang=js"
export * from "./image-magnifier.vue?vue&type=script&setup=true&lang=js"

import "./image-magnifier.vue?vue&type=style&index=0&id=2b120cc6&scoped=true&lang=css"

import exportComponent from "/Users/nikhiltongya/Desktop/Anatta Projects/stio-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b120cc6"]])

export default __exports__